const accordions = document.querySelectorAll('.accordion');

accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion__item');

    items.forEach((el) => {
        el?.addEventListener('click', (e) => {
            toggleAccordionItem(el, accordion);
        });
    });
});

const getSiblings = (elm, withTextNodes) => {
    if (!elm || !elm.parentNode) return;

    let siblings = [
            ...elm.parentNode[withTextNodes ? 'childNodes' : 'children'],
        ],
        idx = siblings.indexOf(elm);

    siblings.before = siblings.slice(0, idx);
    siblings.after = siblings.slice(idx + 1);

    return siblings;
};

function toggleAccordionItem(item, accordion) {
    const state = item.dataset.state;

    if (state == 'opened') {
        item.dataset.state = 'closed';
    } else if (state == 'closed') {
        item.dataset.state = 'opened';
    }

    item.querySelector('.wp-block-faq__answer').addEventListener(
        'transitionstart',
        function faqImageChange(e) {
            if (e.propertyName == 'max-height') {
                return;
            }
            getSiblings(item).forEach((el) => {
                if (el == item) {
                  return;
                }
                el.dataset.state = 'closed';
            });

            item.querySelector('.wp-block-faq__answer').removeEventListener(
                'transitionstart',
                faqImageChange
            );
        }
    );
    return;
}
